
const isProdCache = (() => {
  if (window.location.hostname === 'localhost') {
    return false
  }

  if (window.location.hostname === 'consumer-local.leaguesafe.com') {
    return false
  }

  if (window.location.hostname.includes('shub.dog')) {
    return false
  }

  return true
})()

export const isProd = () => isProdCache

export const isLocal = () => {
  return window.location.hostname === 'localhost'
}

export const getENV = () => {
  return isProd() ? 'https://assets.shgn.com' : 'https://assets.shub.dog'
}



// WEBPACK FOOTER //
// ./src/tools/env.js